import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

import { CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_OPTIONS } from '../constants';

const Container = styled.div`
  padding: 10px 20px;
`;

const GeneralLabel = styled.div`
  font-family: var(--font-bold);
  font-size: 12px;
  margin-bottom: 10px;
`;

const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
`;

const CMASummaryRoomComparisonTypeSelector = () => (
  <Container>
    <GeneralLabel>GENERAL</GeneralLabel>
    <Form.Item
      name="roomComparisonType"
      valuePropName="checked"
      getValueFromEvent={(e) =>
        e.target.checked
          ? CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_OPTIONS.ADVANCED_COMPARISON
          : CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_OPTIONS.SIMPLE_COMPARISON
      }
      getValueProps={(value) => ({
        checked: value === CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_OPTIONS.ADVANCED_COMPARISON,
      })}
    >
      <StyledCheckbox className="green">Use rate and care display</StyledCheckbox>
    </Form.Item>
  </Container>
);

export default CMASummaryRoomComparisonTypeSelector;
